import fetchTalkAndPokeApi from './TalkAndPokeFetcher.js';

//GET
export const getCreatorPosters = async (accessToken) => {
    return await fetchTalkAndPokeApi('poster/editor', accessToken, [], 'GET');
};